import { useMemo } from "react"
import { flatJoin } from "shared/util"
import { Link, Stack, Typography } from "@mui/material"
import { Section, SectionProps } from "components/controls/section"
import { SisetuResult } from "interface/sisetu"
import { useSearch } from "features/search/context"

type SisetuGuideLinesProps = {
	sisetu: SisetuResult
} & SectionProps
export const SisetuGuideLines = ({
	sisetu,
	...others
}: SisetuGuideLinesProps) => {
	const search = useSearch()
	const guideLineTypes = useMemo(
		() => {
			if (!search) return []
			if (!search.guideLine || search.guideLine.length === 0) return []
			if (!sisetu.guideLine || sisetu.guideLine.length === 0) return []

			const DEF = '__default_'
			const guideLineMaster = search.guideLine
			const guideLineData = sisetu.guideLine

			const sisetuGuideLineTypes: string[] = []
			guideLineMaster.forEach(guideLine => {
				const guideLineType = guideLine.guideLineType ?? DEF
				if (guideLine.hasHospital && sisetuGuideLineTypes.includes(guideLineType) === false) {
					sisetuGuideLineTypes.push(guideLineType)
				}
			})
			sisetuGuideLineTypes.sort((a, b) => a === DEF ? -1 : b === DEF ? 1 : a.localeCompare(b))

			return sisetuGuideLineTypes.flatMap(
				guideLineType => {
					const guideLines = guideLineData.flatMap(
						guide => {
							const guideLine = guideLineMaster.find(guideLine => guideLine.guideLineId === guide.guideLineId)
							if (!guideLine) return []
							if ((guideLine.guideLineType ?? null) !== (guideLineType === DEF ? null : guideLineType)) return []
							return {
								...guide,
								url: guideLine.sourceUrl
							}
						}
					)
					return (guideLines.length === 0) ? [] : {
						guideLineType,
						guideLines
					}					
				}
			)
		},
		[search, sisetu]
	)
	return guideLineTypes.map(
		({ guideLineType, guideLines }) => (
			<Section
				key={`type-${guideLineType}`}
				label={guideLineType ?? "ガイドライン"}
				{...others}
			>
				<Stack
					direction="column"
					spacing={0.5}
				>
					{guideLines.map(({ url, guideLineName, hospitalClass }, i) => url ? (
						<Link key={`guide-${i}`} href={url} target="_blank" variant="body2" underline='hover' className='guideline'>
							{flatJoin(' ', guideLineName, hospitalClass)}
						</Link>
					) : (
						<Typography key={`guide-${i}`} variant="body2" color='text.primary' component="span" className='guideline'>
							{flatJoin(' ', guideLineName, hospitalClass)}
						</Typography>
					))}
				</Stack>
			</Section>
		)
	)
}